export default __webpack_public_path__ + "static/media/history-bg.a1f4e9d5.webp";